import { compileSchema } from '@toolproof-core/validation/_pure/schema-compilation';

import { parseDirectionCatalog, selectDirectionRuleEffects } from '@/_pure/directionRule';
import effectSchema from '@/adapters/primitive/_contract/_@schema/directions/operationEffect.schema.json' with { type: 'json' };
import directionRulesJson from '@/adapters/primitive/_data/directions/directionRules.json' with { type: 'json' };
import { PRIMITIVE_MOMENT_VOCABULARY } from './primitiveMoment';
import type { MomentInstant, MomentVocabulary } from '@/_contract/_~generated/directionMomentSchema';
import type { DirectionCatalog } from '@/_contract/directionRule';
import type { PrimitiveOperationDirectionEffect } from '@/adapters/primitive/_contract/_~generated/operationDirectionEffect';

export function parsePrimitiveDirectionCatalog(
    value: unknown, vocabulary: MomentVocabulary = PRIMITIVE_MOMENT_VOCABULARY,
): DirectionCatalog<PrimitiveOperationDirectionEffect> {
    const validator = compileSchema(effectSchema);
    return parseDirectionCatalog(value, vocabulary, effect => {
        const result = validator.validate(effect);
        if (!result.valid) {
            throw new Error(`Invalid primitive direction effect: ${result.issues.map(issue => `${issue.instancePath} ${issue.message}`).join('; ')}`);
        }
        return effect as PrimitiveOperationDirectionEffect;
    });
}

export const PRIMITIVE_DIRECTION_CATALOG = parsePrimitiveDirectionCatalog(directionRulesJson);

export function selectPrimitiveDirectionEffects(
    instant: MomentInstant,
    catalog: DirectionCatalog<PrimitiveOperationDirectionEffect> = PRIMITIVE_DIRECTION_CATALOG,
    isIncluded: (key: string) => boolean = () => false,
): readonly PrimitiveOperationDirectionEffect[] {
    return selectDirectionRuleEffects(catalog, instant, isIncluded);
}
